/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderMyStatsDto } from '../../models/order-my-stats-dto';

export interface OrderControllerGetMyStats$Params {
}

export function orderControllerGetMyStats(http: HttpClient, rootUrl: string, params?: OrderControllerGetMyStats$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderMyStatsDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerGetMyStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderMyStatsDto>;
    })
  );
}

orderControllerGetMyStats.PATH = '/api/orders/stats/me';
